import { getDataSourceIcon } from './getDataSourceImg';

import type { IGameType } from '@/pages/intelligence/types/common';

export type IMobileDataSource = 'appstore' | 'googleplay' | (string & {});

export type IPCDataSource = 'steam' | 'epic' | (string & {});

export type IConsoleDataSource = 'playstation' | 'xbox' | 'nintendo' | (string & {});

interface IDataSourceInfo {
  name: string;
  icon: string;
}

// mobile
const BDI_MOBILE_DATASOURCE_INFO: {
  [key in IMobileDataSource]: IDataSourceInfo;
} = {
  appstore: {
    name: 'App Store',
    icon: getDataSourceIcon('appstore'),
  },
  googleplay: {
    name: 'Google Play',
    icon: getDataSourceIcon('googleplay'),
  },
  unified: {
    name: 'Unified',
    icon: getDataSourceIcon('unified'),
  },
};

const BDI_PC_DATASOURCE_INFO: {
  [key in IPCDataSource]: IDataSourceInfo;
} = {
  steam: {
    name: 'Steam',
    icon: getDataSourceIcon('steam'),
  },
  epic: {
    name: 'Epic Games',
    icon: getDataSourceIcon('epic'),
  },
};

const BDI_CONSOLE_DATASOURCE_INFO: {
  [key in IConsoleDataSource]: IDataSourceInfo;
} = {
  playstation: {
    name: 'Playstation',
    icon: getDataSourceIcon('playstation'),
  },
  xbox: {
    name: 'Xbox',
    icon: getDataSourceIcon('xbox'),
  },
  nintendo: {
    name: 'Nintendo',
    icon: getDataSourceIcon('nintendo'),
  },
};

const BDI_DOUYIN_DATASOURCE_INFO: {
  [key in IConsoleDataSource]: IDataSourceInfo;
} = {
  douyin: {
    name: 'Douyin',
    icon: getDataSourceIcon('douyin'),
  },
};

export const getMobileDataSourceInfo = (dataSource: IMobileDataSource): IDataSourceInfo =>
  BDI_MOBILE_DATASOURCE_INFO[dataSource] ?? { name: '', icon: '' };

export const getPCDataSourceInfo = (dataSource: IPCDataSource): IDataSourceInfo =>
  BDI_PC_DATASOURCE_INFO[dataSource] ?? { name: '', icon: '' };

export const getConsoleDataSourceInfo = (dataSource: IConsoleDataSource): IDataSourceInfo =>
  BDI_CONSOLE_DATASOURCE_INFO[dataSource] ?? { name: '', icon: '' };

export const getDouYinDataSourceInfo = (dataSource: IConsoleDataSource): IDataSourceInfo =>
  BDI_DOUYIN_DATASOURCE_INFO[dataSource] ?? { name: '', icon: '' };

export const getDataSourceInfo = (
  entityType: IGameType,
  dataSource: IMobileDataSource | IPCDataSource | IConsoleDataSource,
): IDataSourceInfo => {
  if (entityType === 'mobile') return getMobileDataSourceInfo(dataSource);
  if (entityType === 'pc') return getPCDataSourceInfo(dataSource);
  if (entityType === 'console') return getConsoleDataSourceInfo(dataSource);
  if (entityType === 'douyin') return getDouYinDataSourceInfo(dataSource);
  return {
    name: '',
    icon: '',
  };
};
